import { render, staticRenderFns } from "./ShiftsPopup.vue?vue&type=template&id=0199a986"
import script from "./ShiftsPopup.vue?vue&type=script&lang=ts"
export * from "./ShiftsPopup.vue?vue&type=script&lang=ts"
import style0 from "./ShiftsPopup.vue?vue&type=style&index=0&id=0199a986&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports